import React from "react";
import { Loader2, AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PageLoader({ label = "Cargando…" }: { label?: string }) {
  return (
    <div className="flex justify-center h-96 items-center" role="status">
      <Loader2 className="w-7 h-7 text-gold-ink animate-spin" aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </div>
  );
}

// Distingue "falló la carga" de "no hay datos": antes ambos se veían como una lista vacía.
export function LoadError({ what, onRetry }: { what: string; onRetry: () => void }) {
  return (
    <div className="card-obsidian p-10 text-center" role="alert" data-testid="load-error">
      <AlertTriangle className="w-9 h-9 text-amber-700 mx-auto mb-3" aria-hidden="true" />
      <p className="text-slate-800 font-medium">No pudimos cargar {what}.</p>
      <p className="text-sm text-slate-600 mt-1">Revisa tu conexión y vuelve a intentarlo. Si el problema sigue, avisa a soporte.</p>
      <Button onClick={onRetry} variant="outline" className="mt-5 rounded-full border-slate-300" data-testid="load-error-retry">
        <RefreshCw className="w-4 h-4 mr-1.5" aria-hidden="true" /> Reintentar
      </Button>
    </div>
  );
}

export function EmptyState({ icon: Icon, children }: { icon?: React.ComponentType<any>; children: React.ReactNode }) {
  return (
    <div className="card-obsidian p-10 text-center text-slate-600" data-testid="empty-state">
      {Icon && <Icon className="w-10 h-10 text-slate-400 mx-auto mb-3" aria-hidden="true" />}
      {children}
    </div>
  );
}
